import { Link } from "react-router-dom"
import { cn } from "@/shared/lib/utils"
import styles from "./Breadcrumb.module.scss"
import { MaterialIcon } from "@/ui/material-icon"

export type BreadcrumbItem = string | { label: string; to?: string }

interface BreadcrumbProps {
  items: BreadcrumbItem[]
  className?: string
}

function itemLabel(item: BreadcrumbItem): string {
  return typeof item === "string" ? item : item.label
}

const Breadcrumb = ({ items, className }: BreadcrumbProps) => {
  return (
    <nav className={cn(styles.breadcrumb, className)} aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1
        const label = itemLabel(item)
        const to = typeof item === "object" && item.to ? item.to : undefined

        let content: React.ReactNode

        if (isLast) {
          content = (
            <span className={cn(styles.label, styles.active)}>
              {label}
            </span>
          )
        } else if (to) {
          content = (
            <Link to={to} className={styles.link}>
              {label}
            </Link>
          )
        } else {
          content = <span className={styles.label}>{label}</span>
        }

        return (
          <span key={`${label}-${index}`} className={styles.item}>
            {content}

            {!isLast && (
              <MaterialIcon
                name="chevron_right"
                size={16}
                className={styles.separator}
              />
            )}
          </span>
        )
      })}
    </nav>
  )
}

export default Breadcrumb